<template>
    <div>
         <b-form-group
            description=""
            label="24h Clock"
            label-for="is24h"
            :label-cols="3"
            :horizontal="false">
                <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.custom_data.timepicker.is24h"/>
        </b-form-group>

         <b-form-group
            description=""
            label="Show seconds"
            label-for="showSeconds"
            :label-cols="3"
            :horizontal="false">
                <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.custom_data.timepicker.showSeconds"/>
        </b-form-group>

        <InputField 
            type="text" 
            name="minuteStep" 
            label="Minute step" 
            v-model.number="constraints.custom_data.timepicker.minuteStep" 
            @error="fieldError"
            :rules="{required: false, length: {min: 1, max: 30}, expression: this.validate}"
        />
    </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import InputField from '@/components/form/Input'

export default {
    components: {
        cSwitch,
        InputField
    },
    props: {
        value: {
            type: Object
        }
    },
    data: function() {
        return {
            errors: []
        }
    },
    watch: {
        errors(val) {
            this.$emit('error', val[0])
        }
    },
    computed: {
        constraints() {
            let base = this.value

            base.custom_data = base.custom_data || {
                timepicker: {
                    is24h: false,
                    showSeconds: false,
                    minuteStep: 1
                }
            }

            base.custom_data.timepicker = base.custom_data.timepicker || {}

            return base;
        }
    },
    methods: {
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        validate(val) {
            if (val == NaN) {
                return []
            }

            if (60 % val != 0) {
                return ['Must be a value evenly divided into 60']
            }

            return []
        }
    }
    
}
</script>